import { Directive, Input, OnChanges, SimpleChanges, ViewContainerRef } from '@angular/core';
import { Section } from '../../../editor-container/editor-model';
import { DynamicRendererComponent } from '@urbannex/storethemes';

@Directive({
  selector: '[kveBuilderHost]'
})
export class BuilderHostDirective implements OnChanges {
  @Input() section: Section;
  @Input() edit: boolean;
  @Input() rendererComponent: DynamicRendererComponent;

  constructor(public viewContainerRef: ViewContainerRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["section"]) {
      console.log(this.section);
    }
    if (changes["edit"]) {
      console.log(this.edit);
    }
  }

}
